<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Extender Information of Applicant
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      .row
        .col-md-8
      ValidationObserver(ref="Validation" slim)
        .row
          .col-12
            h4.mb-3 SPOUSE INFORMATION <i>(fill up if married)</i>
          .col-md-6
            ValidationProvider(name="spouse first name", :rules="{required: isSpoiceRequired}" v-slot="{errors}" slim)
              .form-group
                label(for="spouceFirstName") First Name
                input.form-control#spouceFirstName(:class="{'border-danger': errors.length}" type="text" name="spouceFirstName" placeholder="" v-model="form.spouceFirstName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="spouse middle name", :rules="{required: isSpoiceRequired}" v-slot="{errors}" slim)
              .form-group
                label(for="spouceMiddleName") Middle Name
                input.form-control#spouceMiddleName(:class="{'border-danger': errors.length}" type="text" name="spouceMiddleName" placeholder="" v-model="form.spouceMiddleName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="spouse last name", :rules="{required: isSpoiceRequired}" v-slot="{errors}" slim)
              .form-group
                label(for="spouceLastName") Last Name
                input.form-control#spouceLastName(:class="{'border-danger': errors.length}" type="text" name="spouceLastName" placeholder="" v-model="form.spouceLastName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
          .col-md-6
            ValidationProvider(name="date employed" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="spouceDateEmployed") Date Employed
                date-picker.w-100(v-model="form.spouceDateEmployed" valueType="format", :input-class="['form-control', (errors.length > 0 ?'border-danger': '')]")
                //- input.form-control#spouceDateEmployed(:class="{'border-danger': errors.length}" type="text" name="spouceDateEmployed" placeholder="" v-model="form.spouceDateEmployed")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="spouse employment" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="spouceEmployment") Spouse Employment
                input.form-control#spouceEmployment(:class="{'border-danger': errors.length}" type="text" name="spouceEmployment" placeholder="" v-model="form.spouceEmployment")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="spouse position" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="spoucePosition") Spouse Position
                input.form-control#spoucePosition(:class="{'border-danger': errors.length}" type="text" name="spoucePosition" placeholder="" v-model="form.spoucePosition")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
          // End of spouce information
          .col-12
            h4.mb-3 MOTHER INFORMATION (Maiden)
          .col-md-6
            ValidationProvider(name="mother first name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="motherFirstName") First Name
                input.form-control#motherFirstName(:class="{'border-danger': errors.length}" type="text" name="motherFirstName" placeholder="" v-model="form.motherFirstName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="mother middle name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="motherMiddleName") Middle Name
                input.form-control#motherMiddleName(:class="{'border-danger': errors.length}" type="text" name="motherMiddleName" placeholder="" v-model="form.motherMiddleName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
          .col-md-6
            ValidationProvider(name="mother last name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="motherLastName") Last Name
                input.form-control#motherLastName(:class="{'border-danger': errors.length}" type="text" name="motherLastName" placeholder="" v-model="form.motherLastName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="mother suffix" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="motherSuffix") Suffix <i>(optional)</i>
                input.form-control#motherSuffix(:class="{'border-danger': errors.length}" type="text" name="motherSuffix" placeholder="" v-model="form.motherSuffix")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
          // End of Mothers information
          .col-12
            h4.mb-3 FATHER INFORMATION
          .col-md-6
            ValidationProvider(name="father first name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="fatherFirstName") First Name
                input.form-control#fatherFirstName(:class="{'border-danger': errors.length}" type="text" name="fatherFirstName" placeholder="" v-model="form.fatherFirstName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="father middle name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="fatherMiddleName") Middle Name
                input.form-control#fatherMiddleName(:class="{'border-danger': errors.length}" type="text" name="fatherMiddleName" placeholder="" v-model="form.fatherMiddleName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
          .col-md-6
            ValidationProvider(name="father last name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="fatherLastName") Last Name
                input.form-control#fatherLastName(:class="{'border-danger': errors.length}" type="text" name="fatherLastName" placeholder="" v-model="form.fatherLastName")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="father suffix" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="fatherSuffix") Suffix <i>(optional)</i>
                input.form-control#fatherSuffix(:class="{'border-danger': errors.length}" type="text" name="fatherSuffix" placeholder="" v-model="form.fatherSuffix")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
</template>

<style scoped=""></style>

<script>
import { ref, reactive, computed } from '@vue/composition-api';

export default {
  name: 'OtherInfo',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  emits: ['prev', 'next', 'input'],

  setup(props, { emit }) {
    const form = reactive(props.value);
    const Validation = ref(null);
    const prev = () => {
      emit('prev');
    };
    const next = () => {
      emit('next');
    };
    const validate = () => {
      emit('input', form);
      return Validation.value.validate().then((success) => {
        if (success) {
          return Promise.resolve(success);
        }
        return Promise.reject(success);
      });
    };
    const isSpoiceRequired = computed(() => {
      return !!form.spouceFirstName || !!form.spouceMiddleName || !!form.spouceLastName;
    });
    return {
      isSpoiceRequired,
      form,
      Validation,
      prev,
      next,
      validate,
    };
  },
};
</script>
